import { CarouselProvider, Slider, Slide, DotGroup } from "pure-react-carousel"
import "pure-react-carousel/dist/react-carousel.es.css"
import Card from "components/WideArticleCard"
import Divider from "components/Divider"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function WideCardCaousel({ category, cards }) {
  return (
    <div className="max-w-screen-xl mx-auto">
      <Divider />
      <h2 className="text-center text-gray-light">{category}</h2>
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={200}
        totalSlides={cards.length}
        visibleSlides={1}
        isPlaying
        interval={5000}
        isIntrinsicHeight
      >
        <Slider className="py-10">
          {cards.map((card, idx) => (
            <Slide key={idx}>
              <Card
                video={{ component: "yt_embed", id: card?.content?.video_id }}
                link={getStoryblokLink(card?.content?.link)}
                cta_text={card.content.cta_text}
                image={card?.content?.image}
                title={card?.content?.title}
                description={card?.content?.description}
              />
            </Slide>
          ))}
        </Slider>
        {cards.length > 1 && <DotGroup className="prc-dotGroup" />}
      </CarouselProvider>
    </div>
  )
}
